import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React from "react";
import { classNames } from "primereact/utils";
import { useForm, Controller, UseFormReset } from "react-hook-form";
import { Message } from "primereact/message";

interface Props {
  setter: () => void;
  add: (param: any, reset: UseFormReset<any>) => void;
  errorDialog: boolean;
  metaDataDuplicated: boolean;
}

export const Metadonee = ({
  setter,
  errorDialog,
  add,
  metaDataDuplicated,
}: Props) => {
  const defaultValues: any = {
    name: "",
    value: "",
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ defaultValues });

  const onSubmitHandler = (data: any) => {
    add(data, reset);
  };

  const footerDialog = () => {
    return (
      <>
        <Button
          label={"ANNULER"}
          disabled={false}
          onClick={() => setter()}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={() => {
            handleSubmit(onSubmitHandler)();
          }}
          type="submit"
          label={"CRÉER"}
          className="p-button p-button-sm"
        />
      </>
    );
  };

  return (
    <>
      <Dialog
        header={"Créer une nouvelle métadonnée"}
        footer={footerDialog}
        visible={errorDialog}
        style={{ width: "25vw" }}
        modal
        onHide={() => {
          setter();
        }}
      >
        <form id="hook-form" onSubmit={handleSubmit(onSubmitHandler)}>
          <div className="field mt-4">
            <div className="grid p-fluid">
              <div className="col-5 p-field">
                <span className="p-float-label">
                  <Controller
                    name="name"
                    control={control}
                    rules={{
                      required: "Le name est obligatoire",
                    }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        {...field}
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />
                  <label
                    htmlFor="name"
                    className={classNames({
                      "p-error": errors.name,
                    })}
                  >
                    name*
                  </label>
                </span>
              </div>
              <div className="col-1 p-field text-center mt-2">=</div>
              <div className="col-5 p-field">
                <span className="p-float-label">
                  <Controller
                    name="value"
                    control={control}
                    rules={{
                      required: "La value est obligatoire",
                    }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        {...field}
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />
                  <label
                    htmlFor="value"
                    className={classNames({
                      "p-error": errors.value,
                    })}
                  >
                    value*
                  </label>
                </span>
              </div>
            </div>
          </div>
          {
            metaDataDuplicated &&
            <div className="mt-5 mb-5">
            <Message
              className="w-full"
              severity="error"
              text={
                  "Ce nom déjà utilisé par une metadonnée, merci d'essayer avec un nom différent."
              }
            />
          </div>
          }
   
        </form>
      </Dialog>
    </>
  );
};
